import type { MaybeRefOrGetter } from 'vue';
import type { UploadFileOptions } from '#layers/assets/stores/upload';
import type { MonospaceFile } from '#layers/data-model';
import { readonly, ref, toValue } from 'vue';
import { useUploadStore } from '#layers/assets/stores/upload';

interface UseFileUploadOptions extends UploadFileOptions {}

export function useFileUpload(options: MaybeRefOrGetter<UseFileUploadOptions> = {}) {
	const uploadStore = useUploadStore();

	const isUploading = ref(false);

	async function uploadFiles(files: File[]): Promise<MonospaceFile[]> {
		if (files.length === 0) return [];

		isUploading.value = true;

		const uploadedFiles = await uploadStore.uploadFiles(files, toValue(options));

		isUploading.value = false;

		return uploadedFiles;
	}

	return {
		uploadFiles,
		isUploading: readonly(isUploading),
	};
}
